import { EMAIL_FIELD_SCHEMA, PHONE_FIELD_SCHEMA } from 'app/pages/crm/shared/crm.constants';
import { object, string } from 'yup';

import {
  COMPANY_NAME_MAX_LENGTH,
  CONTACT_FORM_FIELD,
  FIRST_NAME_MAX_LENGTH,
  LAST_NAME_MAX_LENGTH,
} from './NewContactDrawer.constants';

export const buildPersonSchema = () =>
  object().shape({
    [CONTACT_FORM_FIELD.FIRST_NAME]: string()
      .required('First name is required')
      .max(FIRST_NAME_MAX_LENGTH),
    [CONTACT_FORM_FIELD.LAST_NAME]: string()
      .required('Last name is required')
      .max(LAST_NAME_MAX_LENGTH),
    [CONTACT_FORM_FIELD.COMPANY_NAME]: string().nullable(),
    [CONTACT_FORM_FIELD.PRIMARY_EMAIL]: EMAIL_FIELD_SCHEMA.nullable(),
    [CONTACT_FORM_FIELD.PRIMARY_PHONE]: PHONE_FIELD_SCHEMA.nullable(),
  });

export const buildCompanySchema = () =>
  object().shape({
    [CONTACT_FORM_FIELD.FIRST_NAME]: string().nullable(),
    [CONTACT_FORM_FIELD.LAST_NAME]: string().nullable(),
    [CONTACT_FORM_FIELD.COMPANY_NAME]: string()
      .required('Company name is required')
      .max(COMPANY_NAME_MAX_LENGTH),
    [CONTACT_FORM_FIELD.PRIMARY_EMAIL]: EMAIL_FIELD_SCHEMA.nullable(),
    [CONTACT_FORM_FIELD.PRIMARY_PHONE]: PHONE_FIELD_SCHEMA.nullable(),
  });
